import LoadingIndicator from "~/components/LoadingIndicator";
import {
  Size,
  SizeField,
  SizeFieldInput,
  SizeFieldStock,
  SizeLabel,
  SizeModifier,
  SizePrice,
  SizeTop,
  Sizes,
} from "~/components/ProductQuantitySelector/components";
import {
  InventoryVariant,
  PriceVariant,
  Variant,
} from "~/entities/variant/types";
import { formatCurrency } from "~/utils/number";

export type InventoryPriceVariant = Variant & InventoryVariant & PriceVariant;

type Props = {
  isLoading?: boolean;
  inventoryPriceVariants: InventoryPriceVariant[];
};

const ProductQuantitySelector: React.FC<Props> = ({
  inventoryPriceVariants,
  isLoading,
}) => (
  <Sizes>
    {inventoryPriceVariants.map((variant) => (
      <Size key={`quantity-selector-size-${variant.id}`}>
        <SizeTop>
          <SizeLabel>{variant.size}</SizeLabel>
          <SizePrice>
            {isLoading ? (
              <LoadingIndicator size="small" />
            ) : (
              formatCurrency(variant.price)
            )}
          </SizePrice>
          <SizeModifier variant={variant} />
        </SizeTop>
        <SizeField>
          <SizeFieldInput
            id={variant.id}
            size={variant.size}
            max={variant.inventory}
            isLoading={isLoading}
          />
          <SizeFieldStock>
            {isLoading ? null : variant.inventory.toLocaleString()}
          </SizeFieldStock>
        </SizeField>
      </Size>
    ))}
  </Sizes>
);

export default ProductQuantitySelector;
